import { AclAction } from 'shared/domains/apollo/generated/types';
import useAccount from 'shared/domains/users/hooks/useAccount';
import { useCurrentUserTeamIds } from './useCurrentUserTeamIds';
export function useACLCan(params) {
    const { userAcls, teamAcls } = params;
    const account = useAccount();
    const { teamIds } = useCurrentUserTeamIds();
    const can = (action) => (userId = account.data.userId) => {
        if (account.data.role === 'owner') {
            if (action === AclAction.Traverse) {
                return false;
            }
            return true;
        }
        const hasUserAccess = userAcls === null || userAcls === void 0 ? void 0 : userAcls.some((access) => access.userId === userId && access.actions.includes(action));
        const hasTeamAccess = teamAcls === null || teamAcls === void 0 ? void 0 : teamAcls.some((access) => teamIds.includes(access.teamId) && access.actions.includes(action));
        // Because of legacy reasons, lets assume all data can be undefined.
        const hasAccessTroughProject = teamAcls === null || teamAcls === void 0 ? void 0 : teamAcls.some((access) => {
            var _a, _b, _c;
            const isProjectTeam = (_a = access.team) === null || _a === void 0 ? void 0 : _a.isProjectTeam;
            const hasAction = access.actions.includes(action);
            const userIsTeamMember = Boolean((_c = (_b = access.team) === null || _b === void 0 ? void 0 : _b.members) === null || _c === void 0 ? void 0 : _c.some((member) => member.userId === userId));
            return isProjectTeam && hasAction && userIsTeamMember;
        });
        return Boolean(hasUserAccess || hasTeamAccess || hasAccessTroughProject);
    };
    const getAccessLevel = () => {
        if (can(AclAction.Write)()) {
            return 'full';
        }
        if (can(AclAction.Read)()) {
            return 'read';
        }
        if (can(AclAction.Traverse)()) {
            return 'traverse';
        }
        return 'none';
    };
    return {
        canTraverse: can(AclAction.Traverse),
        canRead: can(AclAction.Read),
        canWrite: can(AclAction.Write),
        canDelete: can(AclAction.Delete),
        accessLevel: getAccessLevel(),
    };
}
